
// search script

$(document).ready(function(){

	$("#search-wrapper").click(function(){

		$(".open-search").slideToggle(600);

	});

	$("#search-wrapper01").click(function(){

		$(".open-search").slideToggle(600);

	});



});